<template>
  <div>
    <StoreSwitcher v-if="isAdmin" />
    <CommissionsReportFilter v-model="filter" @filter="loadReport" />

    <StateRenderer v-bind="report">
      <b-row class="mb-3">
        <b-col md="3" sm="6" class="mb-2">
          <b-card>
            <small class="text-muted">Faturamento</small>
            <div class="h5 mb-0">
              {{ formatCurrency(periodSummary.totalAmount) }}
            </div>
          </b-card>
        </b-col>
        <b-col md="3" sm="6" class="mb-2">
          <b-card>
            <small class="text-muted">Vendas Efetivas</small>
            <div class="h5 mb-0">{{ periodSummary.totalSales }}</div>
          </b-card>
        </b-col>
        <b-col md="3" sm="6" class="mb-2">
          <b-card>
            <small class="text-muted">Ticket médio</small>
            <div class="h5 mb-0">
              {{ formatCurrency(periodSummary.averageTicket) }}
            </div>
          </b-card>
        </b-col>
        <b-col md="3" sm="6" class="mb-2">
          <b-card>
            <small class="text-muted">Tempo médio</small>
            <div class="h5 mb-0">
              {{ formatMinutes(periodSummary.averagePeriodMinutes) }}
            </div>
          </b-card>
        </b-col>
      </b-row>

      <CommissionsRanking :report="report" />
      <CommissionsLogList :report="report" />
    </StateRenderer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/helpers/date'
import { formatCurrency } from '@/helpers/numbers'
import services from '@/services'
import withAsyncAction from '@/mixins/withAsyncAction'
import StateRenderer from '@/components/StateRenderer'
import StoreSwitcher from '@/components/Stores/StoreSwitcher'
import CommissionsReportFilter from './CommissionsReportFilter'
import CommissionsRanking from './CommissionsRanking'
import CommissionsLogList from './CommissionsLogList'

const firstDayOfCurrentMonth = () => {
  const date = new Date()
  return new Date(date.getFullYear(), date.getMonth(), 1)
}

export default {
  name: 'CommissionsReport',
  components: {
    StateRenderer,
    StoreSwitcher,
    CommissionsReportFilter,
    CommissionsRanking,
    CommissionsLogList
  },
  mixins: [
    withAsyncAction({
      key: 'report',
      initialState: {
        logs: [],
        summary: []
      },
      fetcher: {
        methodName: 'fetchCommissionsReport',
        handler: services.reports.fetchCommissionsReport
      }
    })
  ],
  data() {
    return {
      filter: {
        fromDate: formatDate(firstDayOfCurrentMonth()),
        toDate: formatDate(new Date())
      }
    }
  },
  computed: {
    ...mapGetters('store', ['currentStoreId', 'isAdmin']),
    periodSummary() {
      const summary = this.report?.data?.summary || []
      const totals = summary.reduce(
        (result, item) => ({
          totalAmount: result.totalAmount + Number(item.totalAmount || 0),
          totalSales: result.totalSales + Number(item.totalSales || 0),
          totalPeriodMinutes:
            result.totalPeriodMinutes +
            Number(item.averagePeriodMinutes || 0) *
              Number(item.totalSales || 0)
        }),
        {
          totalAmount: 0,
          totalSales: 0,
          totalPeriodMinutes: 0
        }
      )

      return {
        totalAmount: totals.totalAmount,
        totalSales: totals.totalSales,
        averageTicket:
          totals.totalSales > 0 ? totals.totalAmount / totals.totalSales : 0,
        averagePeriodMinutes:
          totals.totalSales > 0
            ? totals.totalPeriodMinutes / totals.totalSales
            : 0
      }
    }
  },
  watch: {
    currentStoreId() {
      this.loadReport()
    }
  },
  created() {
    this.loadReport()
  },
  methods: {
    formatCurrency,
    loadReport() {
      if (!this.currentStoreId) return

      const { fromDate, toDate } = this.filter
      this.fetchCommissionsReport({
        storeId: this.currentStoreId,
        fromDate,
        toDate
      })
    },
    formatMinutes(value) {
      const minutes = Math.round(Number(value || 0))
      const hours = Math.floor(minutes / 60)
      const remainingMinutes = minutes % 60

      if (hours > 0) {
        return `${hours}h ${remainingMinutes}min`
      }

      return `${remainingMinutes}min`
    }
  }
}
</script>
